import React from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import SentryRow from "../../../../../components/template/sentry-row.jsx";
import useHasPermission from "../../../../../hooks/use-has-permission.js";
import {useQuery} from "@tanstack/react-query";
import sosService from "../../../../../services/web/sos-service.js";
import SosHomeActionItems from "../utils/sos-home-action-items.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import ActionCard from "./sos-home-action-card.jsx";
import useGraphViewportWidth from "../../../../../hooks/use-graph-viewport-width.js";
import {DASH_BREAKPOINTS} from "../../../../../utils/responsive-graph.js";
import {PermissionEnum} from "../../../../../utils/enums/permission-enum.js";

const SosHomeActions = () => {
    const hasPermission = useHasPermission();
    const navigate = navigateHook();
    const vw = useGraphViewportWidth();

    const isCompact = vw < DASH_BREAKPOINTS.desktop;

    const {data} = useQuery({
        queryFn: () => sosService.countOpenEvents(),
        queryKey: ["open-events-count"],
        refetchInterval: 5000,
        staleTime: 5000
    });

    const hasEvent = data > 0;
    const items = SosHomeActionItems.optionsToUser(hasPermission);

    return (
        <Card className={"col-span-4 flex flex-col"}>
            <Card.Header className={"bg-[#031B35]!"}>
                <Card.Title className={"text-white text-[18px]!"}>Ações</Card.Title>
            </Card.Header>
            <Card.Body className={"flex-1 min-h-0 py-4! px-7! bg-linear-to-b from-white to-[#EDF6FF]"}>

                <SentryRow className={"h-full auto-rows-fr " + (isCompact ? "grid-cols-4!" : "grid-cols-5!")}>
                    {
                        hasPermission(PermissionEnum.SOS_MANAGE_EVENTS) &&
                        <ActionCard
                            icon={"img/sos/home/" + (hasEvent ? "sos-open-alert.svg" : "sos-open.svg")}
                            title="SOS em aberto"
                            variant={hasEvent ? "alert" : "default"}
                            onClick={(event) => navigate("/sos/event-open", !event?.ctrlKey)}
                            badge={hasEvent ? (
                                <p className="text-[#AE0000] text-(length:--font-md)! m-0! bg-[#FFB3B3] rounded-lg px-2! py-1! w-fit!">
                                    {data} {data > 1 ? "acionamentos" : "acionamento"} agora
                                </p>
                            ) : <p className={"text-[#676767] text-(length:--font-md)! m-0!"}>Nenhum acionamento</p>}
                        />
                    }

                    {items.map((item) => (
                        <ActionCard
                            key={item.title + item.subTitle}
                            icon={item.icon}
                            title={item.title}
                            subtitle={item.subTitle}
                            onClick={(event) => navigate(item.devUrl, !event?.ctrlKey)}
                        />
                    ))}
                </SentryRow>

            </Card.Body>
        </Card>
    );
};

export default SosHomeActions;
